import styled from "styled-components";
import Row from "./Row";
const FullHeightRow = styled(Row)`
  height: 100%;
`;

export default FullHeightRow;
